import styles from '../markers.module.scss';
import { Icon } from 'leaflet';
import { Popup } from 'react-leaflet';
import { getObjectIcon, IconColor } from '../icons';
import RotatableMarker from '../rotatable-marker/RotatableMarker';
import { RotationModel } from '../utils';
import { useMemo } from 'react';

export enum AssetReportingType {
  Reporting = 'Reporting',
  ReportedOver1DayAgo = 'ReportedOver1DayAgo',
  ReportedOver7DaysAgo = 'ReportedOver7DaysAgo',
  LastSeen = 'LastSeen',
}

export interface AssetPositionMarkerProps extends RotationModel {
  reportingType: AssetReportingType;
  label: string;
}

const getReportingColor = (reportingType: AssetReportingType): IconColor => {
  switch (reportingType) {
    case AssetReportingType.Reporting:
      return IconColor.Green;
    case AssetReportingType.ReportedOver1DayAgo:
      return IconColor.Yellow;
    case AssetReportingType.ReportedOver7DaysAgo:
      return IconColor.Red;
    case AssetReportingType.LastSeen:
      return IconColor.Blue;
  }
};

export function AssetPositionMarker({
  reportingType,
  label,
  position,
  heading,
}: AssetPositionMarkerProps) {
  const icon = useMemo<Icon>(() => {
    const iconColor = getReportingColor(reportingType);
    return getObjectIcon(iconColor, heading);
  }, [reportingType, heading]);

  return (
    <RotatableMarker icon={icon} position={position} heading={heading}>
      <Popup>
        <div className={styles.popup}>{label}</div>
      </Popup>
    </RotatableMarker>
  );
}

export default AssetPositionMarker;
